module.exports = __webpack_public_path__ + "static/media/dancefloor-lighting.1357b57d.jpg";